import gql from 'graphql-tag';

export const GET_THROTTLE_BY_UUID = gql`
  query GetThrottleByUuid($params: ThrottleInput!) {
    throttleByUuid(params: $params) {
      max
      min
      name
      uuid
      description
    }
  }
`;
